import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

function canonicalPath(pathname = "/") {
  if (pathname === "/" || pathname.endsWith("/") || /\/[^/]+\.[^/]+$/.test(pathname)) return pathname;
  return `${pathname}/`;
}

export function PageLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const canonical = canonicalPath(location.pathname);
    if (canonical !== location.pathname) {
      navigate(`${canonical}${location.search}${location.hash}`, { replace: true });
      return undefined;
    }

    const normalizeAnchors = () => {
      document.querySelectorAll('a[href^="/"]').forEach((anchor) => {
        const raw = anchor.getAttribute("href");
        if (!raw || raw.startsWith("//")) return;
        const url = new URL(raw, window.location.origin);
        const normalized = `${canonicalPath(url.pathname)}${url.search}${url.hash}`;
        if (normalized !== raw) anchor.setAttribute("href", normalized);
      });
    };

    normalizeAnchors();
    const observer = new MutationObserver(normalizeAnchors);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href"],
    });
    return () => observer.disconnect();
  }, [location.pathname, location.search, location.hash, navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
